import { printHtml } from "@/components/inventory/shelfPrint";

const esc = (v) => String(v ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const fmtN = (n, d = 0) => Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: d });
const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const fmtMD = (s) => {
  if (!s) return "—";
  const d = new Date(String(s).length <= 10 ? `${s}T00:00:00` : s);
  return isNaN(d) ? esc(s) : `${d.getMonth() + 1}/${d.getDate()}`;
};
const abbrevStatus = (s) => String(s || "").replace(/Picked Up/gi, "PU").replace(/Delivered/gi, "DEL");

const NAVY = "#16337e";

export const printSalesOrdersTable = (rows, meta = {}) => {
  const body = rows.map((r) => `
    <tr>
      <td><b>${esc(r.customer)}</b></td>
      <td>${esc(r.so_number)}</td>
      <td>
        ${r.lines.map((l) => `<div>${esc([l.name, l.design].filter(Boolean).join(" - "))} — <b>${fmtN(l.cases, 1)} cs</b></div>`).join("")}
        <div class="sub">${fmtN(r.total_cases, 1)} total cases</div>
      </td>
      <td>${esc(r.pickup || "—")}</td>
      <td class="r">${fmtMD(r.po_date)}</td>
      <td class="r">${fmtMD(r.rdd)}</td>
      <td class="r">${fmtMD(r.pud)}</td>
      <td class="r">${fmtMD(r.dd)}</td>
      <td>${esc(r.po || "—")}</td>
      <td class="r">${r.price != null ? `<b>${money(r.price)}</b>` : "—"}</td>
      <td>${esc(abbrevStatus(r.status) || "—")}</td>
      <td>${esc(r.ship_from || "—")}</td>
      <td>${esc(r.ship_to || "—").replace(/\n/g, "<br/>")}</td>
      <td class="r">${r.bols || "—"}</td>
      <td>${esc(r.priority || "—")}</td>
    </tr>`).join("");
  const html = `<html><head><title>Sales Orders — ${esc(meta.tabLabel || "")}</title><style>
    @page { size: landscape; margin: 8mm; }
    body { margin: 16px; font-family: 'Helvetica Neue', Arial, sans-serif; color: #0f172a; }
    .hdr { display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 10px; }
    .hdr .t { font-size: 18px; font-weight: 800; color: ${NAVY}; letter-spacing: -0.02em; }
    .hdr .co { font-size: 11px; font-weight: 700; color: #334155; }
    .hdr .m { font-size: 10px; color: #334155; text-align: right; }
    table { width: 100%; border-collapse: collapse; font-size: 8.5px; line-height: 1.35; }
    th { font-size: 7.5px; text-transform: uppercase; letter-spacing: 0.05em; color: ${NAVY}; background: #e9eff8; border: 1px solid #b6c4dd; padding: 3px 5px; text-align: left; }
    td { border: 1px solid #cbd5e1; padding: 4px 5px; vertical-align: top; }
    tr { page-break-inside: avoid; }
    .r { text-align: right; font-variant-numeric: tabular-nums; }
    .sub { color: #64748b; font-size: 7.5px; margin-top: 1px; }
    .totrow td { background: #f1f5fb; font-weight: 800; font-size: 9.5px; }
    .gen { margin-top: 6px; font-size: 7.5px; color: #94a3b8; text-align: right; }
  </style></head><body>
    <div class="hdr">
      <div>
        <div class="t">Sales Orders${meta.tabLabel ? ` — ${esc(meta.tabLabel)}` : ""}</div>
        ${meta.companyName ? `<div class="co">${esc(meta.companyName)}</div>` : ""}
      </div>
      <div class="m">${fmtN(rows.length)} order${rows.length !== 1 ? "s" : ""}${meta.filtered ? " (filtered)" : ""} · ${fmtN(meta.totalCases, 0)} cases${meta.totalRevenue ? ` · ${money(meta.totalRevenue)}` : ""}<br/>Printed ${new Date().toLocaleString()}</div>
    </div>
    <table>
      <tr>
        <th style="width:9%">Customer</th><th style="width:4%">SO #</th><th style="width:21%">Item - Design</th><th style="width:4%">DEL / PU</th>
        <th style="width:4%">Date of PO</th><th style="width:4%">RDD</th><th style="width:4%">PUD</th><th style="width:4%">DD</th>
        <th style="width:8%">Customer PO#</th><th style="width:6%">Price</th><th style="width:7%">Status</th>
        <th style="width:8%">Ship From</th><th style="width:10%">Ship To</th><th style="width:3%">BOLs</th><th style="width:4%">Priority</th>
      </tr>
      ${body}
      <tr class="totrow">
        <td colspan="9">TOTALS — ${fmtN(rows.length)} ORDER${rows.length !== 1 ? "S" : ""} · ${fmtN(meta.totalCases, 0)} CASES</td>
        <td class="r">${meta.totalRevenue ? money(meta.totalRevenue) : "—"}</td>
        <td colspan="5"></td>
      </tr>
    </table>
    <div class="gen">Generated ${new Date().toLocaleString()}</div>
  </body></html>`;
  printHtml(html);
};
